import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';

  
const StockPriceGraph = ({ stockPrice }) => {
    return (
        <div className="stock-fig">
            <ResponsiveContainer width="100%" height={200}>
                <AreaChart data={stockPrice}>
                    <defs>
                    <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#66cdaa" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#81ccb3" stopOpacity={0} />
                    </linearGradient>
                    </defs>
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Area
                    type="linear"
                    dataKey="close"
                    stroke="rgb(45, 186, 77)" 
                    fillOpacity={1}
                    fill="url(#colorPrice)"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    )
}

export default StockPriceGraph
